import { useEffect, useMemo, useRef } from "react";
import useState from "react-usestateref";
import { Button } from "@material-ui/core";
import countryList from "react-select-country-list";
import httpService from "../config/httpCall";
import loaderImage from "../image/Rolling-1s-200px.svg";

import { get_job_details_one } from "../config/apiCall";
import { get_intern_details_one } from "../config/apiCall";
import { internuserFormSubmit } from "../config/apiCall";
import { jobuserFormSubmit } from "../config/apiCall";
import { toast } from "react-toastify";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import NewHead from "./landing/NewHead";

function Home() {
  const [pageType, setPageType] = useState();

  const [count, setCount] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [pageloader, setpageloader] = useState(false);

  const [jobPositionValue, setjobPositionValue, jobPositionValueref] =
    useState();
  const [jobDepartmentValue, setjobDepartmentValue, jobDepartmentValueref] =
    useState();
  const [interndepartmentValue, setinterndepartmentValue] = useState();
  const [internpositionValue, setinternpositionValue] = useState();

  const uploadInput = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setpageloader(false);
    }, 1000);

    var url = window.location.href.split("careerdetails/").at(1);
    console.log("----------------------------");
    // var pageid = localStorage.getItem("pageid");
    var pagetype = url.split("/").at(0);
    // var pagetype = localStorage.getItem("pagetype");
    setPageType(pagetype);
    console.log(pagetype, "pagetype");

    // setinternpositionValue(localStorage.getItem("internposition"));
    // setjobDepartmentValue(localStorage.getItem("jobDepartment"));
    // setinterndepartmentValue(localStorage.getItem("interndepartment"));
    // setjobPositionValue(localStorage.getItem("jobPosition"));

    if (pagetype == "intern") {
      get_intern_details(url.split("/").at(1));
    } else {
      get_job_details(url.split("/").at(1));
    }
  }, [0]);
  const [Details, setdetails, detailsrref] = useState({});
  const [loader, setloader] = useState(false);

  const get_intern_details = async (pageid) => {
    console.log("-0-0-0", pageid);
    try {
      var obj = {
        id: pageid,
      };

      var data = {
        apiUrl: httpService.get_intern_details_one,
        payload: obj,
      };
      setpageloader(true);
      var resp = await get_intern_details_one(data);
      if (resp.status == true) {
        setpageloader(false);

        if (resp.status == true) {
          setdetails(resp.Message.get_interndata);
          console.log(Details, "Details");
          console.log(resp.Message.get_interndata, "Details");
          setinternpositionValue(detailsrref.current.internPosition);
          // setjobDepartmentValue(localStorage.getItem("jobDepartment"));
          setinterndepartmentValue(detailsrref.current.internDepartment);
          // setjobPositionValue(localStorage.getItem("jobPosition"));
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const get_job_details = async (pageid) => {
    console.log("-0-0-0", pageid);

    try {
      try {
        var obj = {
          id: pageid,
        };
        setpageloader(true);
        var resp = await get_job_details_one(obj);
        if (resp.status == true) {
          setpageloader(false);
          setdetails(resp.Message.get_job_data);
          console.log(detailsrref.current, "detailsrref.current");
          setjobPositionValue(detailsrref.current.jobPosition);
          setjobDepartmentValue(detailsrref.current.jobDepartment);
        }
      } catch (error) {
        console.log(error, "error");
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  //INTERNER FUNCTIONALITY =======================
  var internervalues = {
    internerFirstName: "",
    internerLastName: "",
    internerEmail: "",
    internerEducationDetails: "",
  };

  const [internerInputvalues, setinternerInputvalues] =
    useState(internervalues);

  const {
    internerFirstName,
    internerLastName,
    internerEmail,
    internerEducationDetails,
  } = internerInputvalues;

  const internChangeData = async (e) => {
    try {
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setinternersideformInputvalues((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        e.preventDefault();
        console.log(e.target.value, "e.target");
        let formData = { ...internerInputvalues, ...{ [name]: value } };
        setinternerInputvalues(formData);
        console.log(internerInputvalues, "formData");
      }
    } catch (error) {}
  };

  const [internerFirstNameErr, setinternerFirstNameErr, internerFirstNameref] =
    useState(false);
  const [internerLastNameErr, setinternerLastNameErr, internerLastNameref] =
    useState(false);
  const [internerEmailErr, setinternerEmailErr, internerEmailref] =
    useState(false);
  const [
    internerphoneNumberErr,
    setinternerphoneNumberErr,
    internerphoneNumberref,
  ] = useState(false);
  const [
    internerEducationDetailsErr,
    setinternerEducationDetailsErr,
    internerEducationDetailsref,
  ] = useState(false);
  const [internpdfErr, setinternpdfErr, internpdfErrref] = useState();

  const [internermobileValue, setInternerMobileValue] = useState();
  const [validationErrors, setvalidationErrors] = useState("");

  const [internpdf, setinternpdf] = useState();
  const [internpdfName, setinternpdfName] = useState();

  const Internvalidation = async (validateName) => {
    try {
      const errors = {};
      const reg = /^([^0-9$%]*)$/;
      if (!validateName.internerFirstName) {
        setinternerFirstNameErr(true);
        errors.internerFirstName = "Must Enter Your First Name";
      } else if (reg.test(validateName.internerFirstName)) {
        setinternerFirstNameErr(false);
      } else {
        setinternerFirstNameErr(true);
        errors.internerFirstName = "Only should  alphabetic characters";
      }
      if (!validateName.internerLastName) {
        setinternerLastNameErr(true);
        errors.internerLastName = "Must Enter Your Last Name";
      } else if (reg.test(validateName.internerLastName)) {
        setinternerLastNameErr(false);
      } else {
        setinternerLastNameErr(true);
        errors.internerLastName = "Only should  alphabetic characters";
      }

      if (!validateName.internerEducationDetails) {
        setinternerEducationDetailsErr(true);
        errors.internerEducationDetails = "Must Enter  Education Details";
      } else if (reg.test(validateName.internerEducationDetails)) {
        setinternerEducationDetailsErr(false);
      } else {
        setinternerEducationDetailsErr(true);
        errors.internerEducationDetails = "Only should  alphabetic characters";
      }

      if (!validateName.internerEmail) {
        setinternerEmailErr(true);
        errors.internerEmail = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          validateName.internerEmail
        )
      ) {
        setinternerEmailErr(true);
        errors.internerEmail = "Invalid Email Address";
      } else {
        setinternerEmailErr(false);
      }

      if (!internermobileValue) {
        setinternerphoneNumberErr(true);
        errors.internerphoneNumber = " Enter Your Mobile Number";
      } else {
        setinternerphoneNumberErr(false);
      }
      if (!internpdf) {
        setinternpdfErr(true);
        errors.internpdf = " Upload your Resume";
      } else {
        setinternpdfErr(false);
      }
      setvalidationErrors(errors);
    } catch (error) {}
  };

  const internerfileUpload = async (val) => {
    const formData = new FormData();
    formData.append("file", val);
    setloader(true);
    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4YjU4OTIyMS02ZGRlLTRhZDMtYTJkMC1iOWU3OTdiOGU3NzgiLCJlbWFpbCI6ImpvdGhpODg4amRAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6Ijg4NWVlMDgzODVlOTg1Yzc3NjVmIiwic2NvcGVkS2V5U2VjcmV0IjoiNjJlY2RjY2Q3NmVjZTM2NzZjNTU4NTBkNTcyOTdiMmEwNTk3MGMzN2MxMjRlMWMwNGU3NDc2ZmVjODU0MjBmOSIsImV4cCI6MTc2NjIzMzg4Mn0.RAerNGGvx3teDvC3sCVUGxx1_90rqZ_ah3dTIPqUzq4"; // Replace with your Pinata JWT
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;
      setinternpdf(url);
      setinternpdfName(val.name);
      setloader(false);
    } catch (err) {
      console.log(err, "---");
    }
  };
  const internFormSubmit = async () => {
    try {
      Internvalidation(internerInputvalues);
      if (
        internerFirstNameref.current == false &&
        internerLastNameref.current == false &&
        internerEmailref.current == false &&
        internerphoneNumberref.current == false &&
        internerEducationDetailsref.current == false
      ) {
        console.log(internpositionValue, "internpositionValue");
        var internerObj = {
          firstname: internerFirstName,
          lastName: internerLastName,
          Email: internerEmail,
          EducationDetails: internerEducationDetails,
          mobileNumber: internermobileValue,
          internerresume: internpdf,
          internPosition: internpositionValue,
          interndepartment: interndepartmentValue,
        };

        var data = {
          apiUrl: httpService.internFormSubmit,
          payload: internerObj,
        };
        var messageSent = await internuserFormSubmit(data);
        internerInputvalues.internerFirstName = "";
        internerInputvalues.internerLastName = "";
        internerInputvalues.internerEmail = "";
        internerInputvalues.internerEducationDetails = "";
        setinterndepartmentValue("");
        setinternpdf("");
        if (messageSent.success == true) {
          toast.success(messageSent.message);
          window.location.href = "https://beleaftechnologies.com/sucesspage";
        } else {
          toast.error(messageSent.message);
        }
      } else {
        console.log("errororor-0-0-");
      }
    } catch (error) {
      console.log(error, "errororor-0-0-");
    }
  };

  // INTER SIDE FORM  FUCTIONALITY

  var internersideformvalues = {
    internersideformFirstName: "",
    internersideformLastName: "",
    internersideformEmail: "",
    internersideformEducationDetails: "",
  };

  const [internersideformInputvalues, setinternersideformInputvalues] =
    useState(internersideformvalues);

  const {
    internersideformFirstName,
    internersideformLastName,
    internersideformEmail,
    internersideformEducationDetails,
  } = internersideformInputvalues;

  const intern_sideformChangeData = async (e) => {
    try {
      console.log(e, "ddd", e.target.value);
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setinternersideformInputvalues((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        e.preventDefault();
        let formData = { ...internersideformInputvalues, ...{ [name]: value } };
        setinternersideformInputvalues(formData);
      }
    } catch (error) {}
  };

  const [
    internersideformFirstNameErr,
    setinternersideformFirstNameErr,
    internersideformFirstNameref,
  ] = useState(false);
  const [
    internersideformLastNameErr,
    setinternersideformLastNameErr,
    internersideformLastNameref,
  ] = useState(false);
  const [
    internersideformEmailErr,
    setinternersideformEmailErr,
    internersideformEmailref,
  ] = useState(false);
  const [
    internersideformphoneNumberErr,
    setinternersideformphoneNumberErr,
    internersideformphoneNumberref,
  ] = useState(false);
  const [
    internersideformEducationDetailsErr,
    setinternersideformEducationDetailsErr,
    internersideformEducationDetailsref,
  ] = useState(false);
  const [
    internsideformpdfErr,
    setinternsideformpdfErr,
    internsideformpdfErrref,
  ] = useState();

  const [internersideformmobileValue, setInternersideformMobileValue] =
    useState();
  const [internsideformvalidationErrors, setinternsideformvalidationErrors] =
    useState("");

  const [internsideformpdf, setsideforminternpdf] = useState();
  const [sideforminternpdfName, setsideforminternpdfName] = useState();

  const Internsideformvalidation = async (validateName) => {
    try {
      const errors = {};
      const reg = /^([^0-9$%]*)$/;
      if (!validateName.internersideformFirstName) {
        setinternersideformFirstNameErr(true);
        errors.internersideformFirstName = "Must Enter Your First Name";
      } else if (reg.test(validateName.internersideformFirstName)) {
        setinternersideformFirstNameErr(false);
      } else {
        setinternersideformFirstNameErr(true);
        errors.internersideformFirstName = "Only should  alphabetic characters";
      }
      if (!validateName.internersideformLastName) {
        setinternersideformLastNameErr(true);
        errors.internersideformLastName = "Must Enter Your Last Name";
      } else if (reg.test(validateName.internersideformLastName)) {
        setinternersideformLastNameErr(false);
      } else {
        setinternersideformLastNameErr(true);
        errors.internersideformLastName = "Only should  alphabetic characters";
      }

      if (!validateName.internersideformEducationDetails) {
        setinternersideformEducationDetailsErr(true);
        errors.internersideformEducationDetails =
          "Must Enter  Education Details";
      } else {
        setinternersideformEducationDetailsErr(false);
      }

      if (!validateName.internersideformEmail) {
        setinternersideformEmailErr(true);
        errors.internersideformEmail = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          validateName.internersideformEmail
        )
      ) {
        setinternersideformEmailErr(true);
        errors.internerEmail = "Invalid Email Address";
      } else {
        setinternersideformEmailErr(false);
      }

      if (!internersideformmobileValue) {
        setinternersideformphoneNumberErr(true);
        errors.internersideformphoneNumber = " Enter Your Mobile Number";
      } else {
        setinternersideformphoneNumberErr(false);
      }
      if (!internsideformpdf) {
        setinternsideformpdfErr(true);
        errors.internsideformpdf = " Upload your Resume";
      } else {
        setinternsideformpdfErr(false);
      }
      setinternsideformvalidationErrors(errors);
    } catch (error) {}
  };

  const internersideformfileUpload = async (val) => {
    const formData = new FormData();
    formData.append("file", val);
    setloader(true);
    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4YjU4OTIyMS02ZGRlLTRhZDMtYTJkMC1iOWU3OTdiOGU3NzgiLCJlbWFpbCI6ImpvdGhpODg4amRAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6Ijg4NWVlMDgzODVlOTg1Yzc3NjVmIiwic2NvcGVkS2V5U2VjcmV0IjoiNjJlY2RjY2Q3NmVjZTM2NzZjNTU4NTBkNTcyOTdiMmEwNTk3MGMzN2MxMjRlMWMwNGU3NDc2ZmVjODU0MjBmOSIsImV4cCI6MTc2NjIzMzg4Mn0.RAerNGGvx3teDvC3sCVUGxx1_90rqZ_ah3dTIPqUzq4"; // Replace with your Pinata JWT
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;
      setsideforminternpdf(url);
      setsideforminternpdfName(val.name);
      setloader(false);
    } catch (err) {
      console.log(err, "---");
    }
    // try {
    //   console.log("val===", val);
    //   const fileExtension = val.name.split(".").at(-1);
    //   const fileSize = val.size;
    //   const fileName = val.name;
    //   console.log("fileExtension===", fileExtension);
    //   console.log("fileSize===", fileSize);
    //   console.log("fileName===", fileName);
    //   if (
    //     fileExtension == "doc" ||
    //     fileExtension == "docx" ||
    //     fileExtension == "pdf"
    //   ) {
    //     setloader(true);

    //     const apiKey =
    //       "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDBGMTJDNzgxMzQxYjVEOTRBYWQ0YTljRTVmZjQ5ODMyYTMxMzI1OTYiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY5MzU3ODMxNjc2MCwibmFtZSI6Ik5GQyAifQ.u3gspIn2TJ9xjh4mfwnU3ysAUaPGGTsHPKgap9EsqRw"; // Replace with your NFT.Storage API key // Replace with your NFT.Storage API key
    //     const apiUrl = "https://api.nft.storage/upload";

    //     try {
    //       const response = await axios.post(apiUrl, val, {
    //         headers: {
    //           Authorization: `Bearer ${apiKey}`,
    //           "Content-Type": "application/json",
    //         },
    //       });
    //       console.log(response.data.value.cid);

    //       var pdf = `https://nftstorage.link/ipfs/${response.data.value.cid}`;
    //       setsideforminternpdf(pdf);
    //       setloader(false);
    //     } catch (err) {}
    //   } else {
    //     toast.error(
    //       "File does not support. You must use .doc or .docx  or .pdf"
    //     );
    //   }
    // } catch (error) {
    //   // console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-");
    // }
  };
  const internsideFormSubmit = async () => {
    try {
      Internsideformvalidation(internersideformInputvalues);
      if (
        internersideformFirstNameref.current == false &&
        internersideformLastNameref.current == false &&
        internersideformEmailref.current == false &&
        internersideformphoneNumberref.current == false &&
        internersideformEducationDetailsref.current == false
      ) {
        var internerObj = {
          firstname: internersideformFirstName,
          lastName: internersideformLastName,
          Email: internersideformEmail,
          EducationDetails: internersideformEducationDetails,
          mobileNumber: internersideformmobileValue,
          internerresume: internsideformpdf,
          internPosition: internpositionValue,
          interndepartment: interndepartmentValue,
        };

        var data = {
          apiUrl: httpService.internFormSubmit,
          payload: internerObj,
        };
        var messageSent = await internuserFormSubmit(data);
        if (messageSent.success == true) {
          toast.success(messageSent.message);
          window.location.href = "https://beleaftechnologies.com/sucesspage";
          internersideformInputvalues.internersideformFirstName = "";
          internersideformInputvalues.internersideformLastName = "";
          internersideformInputvalues.internersideformEmail = "";
          internersideformInputvalues.internersideformEducationDetails = "";
          setsideforminternpdf("");
        } else {
          toast.error(messageSent.message);
        }
      } else {
        // console.log("errororor-0-0-");
      }
    } catch (error) {
      // console.log(error, "errororor-0-0-");
    }
  };

  //JOB_FUNCRTIONALIEYT PART

  var jobvalues = {
    jobFirstName: "",
    jobLastName: "",
    jobEmail: "",
    jobexperience: "",
    country: "",
  };

  const [jobInputvalues, setjobInputvalues] = useState(jobvalues);

  const { jobFirstName, jobLastName, jobEmail, jobexperience, country } =
    jobInputvalues;

  const jobChangeData = async (e) => {
    try {
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setinternersideformInputvalues((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        e.preventDefault();
        let formData = { ...jobInputvalues, ...{ [name]: value } };
        setjobInputvalues(formData);
        jobValidation(jobInputvalues);
      }
    } catch (error) {}
  };

  const [jobFirstNameErr, setjobFirstNameErr, jobFirstNameref] =
    useState(false);
  const [jobLastNameErr, setjobLastNameErr, jobLastNameref] = useState(false);
  const [jobcountryErr, setjobcountryErr, jobcountryref] = useState(false);
  const [jobResumeErr, setjobResumeErr, jobResumeref] = useState(false);
  const [jobEmailErr, setjobEmailErr, jobEmailref] = useState(false);
  const [jobphoneNumberErr, setjobphoneNumberErr, jobphoneNumberref] =
    useState(false);
  const [jobexperienceErr, setjobexperienceErr, jobexperienceErrref] =
    useState(false);

  const [jobmobileValue, setjobMobileValue] = useState();

  const [jobpdf, setjobpdf] = useState();
  const [jobpdfName, setjobpdfName] = useState();

  const jobfileUpload = async (val) => {
    const formData = new FormData();
    formData.append("file", val);
    setloader(true);
    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4YjU4OTIyMS02ZGRlLTRhZDMtYTJkMC1iOWU3OTdiOGU3NzgiLCJlbWFpbCI6ImpvdGhpODg4amRAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6Ijg4NWVlMDgzODVlOTg1Yzc3NjVmIiwic2NvcGVkS2V5U2VjcmV0IjoiNjJlY2RjY2Q3NmVjZTM2NzZjNTU4NTBkNTcyOTdiMmEwNTk3MGMzN2MxMjRlMWMwNGU3NDc2ZmVjODU0MjBmOSIsImV4cCI6MTc2NjIzMzg4Mn0.RAerNGGvx3teDvC3sCVUGxx1_90rqZ_ah3dTIPqUzq4"; // Replace with your Pinata JWT
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;
      setjobpdf(url);
      setjobpdfName(val.name);
      setloader(false);
    } catch (err) {
      console.log(err, "---");
    }
  };
  // const jobfileUpload = async (val) => {
  //   try {
  //     console.log("val===", val);
  //     const fileExtension = val.name.split(".").at(-1);
  //     const fileSize = val.size;
  //     const fileName = val.name;
  //     console.log("fileExtension===", fileExtension);
  //     console.log("fileSize===", fileSize);
  //     console.log("fileName===", fileName);
  //     if (
  //       fileExtension == "doc" ||
  //       fileExtension == "docx" ||
  //       fileExtension == "pdf"
  //     ) {
  //       setloader(true);

  //       const apiKey =
  //         "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDBGMTJDNzgxMzQxYjVEOTRBYWQ0YTljRTVmZjQ5ODMyYTMxMzI1OTYiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY5MzU3ODMxNjc2MCwibmFtZSI6Ik5GQyAifQ.u3gspIn2TJ9xjh4mfwnU3ysAUaPGGTsHPKgap9EsqRw"; // Replace with your NFT.Storage API key // Replace with your NFT.Storage API key
  //       const apiUrl = "https://api.nft.storage/upload";

  //       try {
  //         const response = await axios.post(apiUrl, val, {
  //           headers: {
  //             Authorization: `Bearer ${apiKey}`,
  //             "Content-Type": "application/json",
  //           },
  //         });
  //         console.log(response.data.value.cid);

  //         var pdf = `https://nftstorage.link/ipfs/${response.data.value.cid}`;
  //         setjobpdf(pdf);
  //         setloader(false);
  //       } catch (err) {}
  //     } else {
  //       toast.error(
  //         "File does not support. You must use .doc or .docx  or .pdf"
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-");
  //   }
  // };

  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);

  const changeHandler = (value) => {
    setValue(value);
    console.log(value, "value");
    jobInputvalues.country = value.label;
  };
  const jobValidation = async (validateName) => {
    try {
      const errors = {};
      const reg = /^([^0-9$%]*)$/;
      if (!validateName.jobFirstName) {
        setjobFirstNameErr(true);
        errors.jobFirstName = "Must Enter Your First Name";
      } else if (reg.test(validateName.jobFirstName)) {
        setjobFirstNameErr(false);
      } else {
        setjobFirstNameErr(true);
        errors.jobFirstName = "Only should  alphabetic characters";
      }
      if (!validateName.jobLastName) {
        setjobLastNameErr(true);
        errors.jobLastName = "Must Enter Your Last Name";
      } else if (reg.test(validateName.jobLastName)) {
        setjobLastNameErr(false);
      } else {
        setjobLastNameErr(true);
        errors.jobLastName = "Only should  alphabetic characters";
      }

      if (!validateName.jobexperience) {
        setjobexperienceErr(true);
        errors.jobexperience = "Must Enter  Experience Details";
      } else {
        setjobexperienceErr(false);
      }

      if (!validateName.jobEmail) {
        setjobEmailErr(true);
        errors.jobEmail = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(validateName.jobEmail)
      ) {
        setjobEmailErr(true);
        errors.jobEmail = "Invalid Email Address";
      } else {
        setjobEmailErr(false);
      }

      if (!validateName.country) {
        setjobcountryErr(true);
        errors.jobcountry = "Choose Your Country";
      } else {
        setjobcountryErr(false);
      }

      if (!jobmobileValue) {
        setjobphoneNumberErr(true);
        errors.jobPhoneNumber = " Enter Your Mobile Number";
      } else {
        setjobphoneNumberErr(false);
      }
      if (!jobpdf) {
        setjobResumeErr(true);
        errors.resume = "Upload Your Resume";
      } else {
        setjobResumeErr(false);
      }
      setvalidationErrors(errors);
    } catch (error) {}
  };

  const jobFormSubmit = async () => {
    try {
      jobValidation(jobInputvalues);

      if (
        jobFirstNameref.current == false &&
        jobLastNameref.current == false &&
        jobResumeref.current == false &&
        jobEmailref.current == false &&
        jobexperienceErrref.current == false &&
        jobphoneNumberref.current == false &&
        jobpdf != ""
      ) {
        var jobObj = {
          firstname: jobInputvalues.jobFirstName,
          lastName: jobInputvalues.jobLastName,
          Email: jobInputvalues.jobEmail,
          Experience: jobInputvalues.jobexperience,
          mobileNumber: jobmobileValue,
          country: jobInputvalues.country,
          resume: jobpdf,
          jobPosition: jobPositionValueref.current,
          jobDepartment: jobDepartmentValueref.current,
        };
        console.log(jobObj, "=-=-=-=-=-=-=-=-=", jobDepartmentValue);
        var data = {
          apiUrl: httpService.jobuserFormSubmit,
          payload: jobObj,
        };
        var messageSent = await jobuserFormSubmit(data);
        if (messageSent.success == true) {
          toast.success(messageSent.message);
          window.location.href = "https://beleaftechnologies.com/sucesspage";

          jobInputvalues.jobFirstName = "";
          jobInputvalues.jobLastName = "";
          jobInputvalues.jobEmail = "";
          jobInputvalues.jobexperience = "";
          jobInputvalues.country = "";
          setjobDepartmentValue("");
          setjobPositionValue("");
          setjobpdf("");
          setjobpdfName("");
        } else {
          toast.error(messageSent.message);
        }
      } else {
        // console.log("errororor-0-0-");
      }
    } catch (error) {
      // console.log(error, "errororor-0-0-");
    }
  };

  //INTERN SIDE FORM FUCTIONALITY

  var jobsideformvalues = {
    jobsideformFirstName: "",
    jobsideformLastName: "",
    jobsideformEmail: "",
    jobsideformexperience: "",
    jobsideformcountry: "",
  };

  const [jobsideformInputvalues, setjobsideformInputvalues] =
    useState(jobsideformvalues);

  const {
    jobsideformFirstName,
    jobsideformLastName,
    jobsideformEmail,
    jobsideformexperience,
    jobsideformcountry,
  } = jobsideformInputvalues;

  const jobsideformChangeData = async (e) => {
    try {
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setinternersideformInputvalues((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        e.preventDefault();
        let formData = { ...jobsideformInputvalues, ...{ [name]: value } };
        setjobsideformInputvalues(formData);
      }
    } catch (error) {}
  };

  const [
    jobsideformFirstNameErr,
    setjobsideformFirstNameErr,
    jobsideformFirstNameref,
  ] = useState(false);
  const [
    jobsideformLastNameErr,
    setjobsideformLastNameErr,
    jobsideformLastNameref,
  ] = useState(false);
  const [
    jobsideformcountryErr,
    setjobsideformcountryErr,
    jobsideformcountryref,
  ] = useState(false);
  const [jobsideformResumeErr, setjobsideformResumeErr, jobsideformResumeref] =
    useState(false);
  const [jobsideformEmailErr, setjobsideformEmailErr, jobsideformEmailref] =
    useState(false);
  const [
    jobsideformphoneNumberErr,
    setjobsideformphoneNumberErr,
    jobsideformphoneNumberref,
  ] = useState(false);
  const [
    jobsideformexperienceErr,
    setjobsideformexperienceErr,
    jobsideformexperienceErrref,
  ] = useState(false);
  // const [jobsideformResumeErr, setjobsideformResumeErr, jobsideformResumeErrref] =
  // useState(false)
  const [jobsideformmobileValue, setjobsideformMobileValue] = useState();

  const [jobsideformpdf, setjobsideformpdf] = useState();
  const [jobsideformpdfName, setjobsideformpdfName] = useState();

  const jobsideformfileUpload = async (val) => {
    const formData = new FormData();
    formData.append("file", val);
    setloader(true);
    const apiUrl = "https://api.pinata.cloud/pinning/pinFileToIPFS";
    const apiKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4YjU4OTIyMS02ZGRlLTRhZDMtYTJkMC1iOWU3OTdiOGU3NzgiLCJlbWFpbCI6ImpvdGhpODg4amRAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6Ijg4NWVlMDgzODVlOTg1Yzc3NjVmIiwic2NvcGVkS2V5U2VjcmV0IjoiNjJlY2RjY2Q3NmVjZTM2NzZjNTU4NTBkNTcyOTdiMmEwNTk3MGMzN2MxMjRlMWMwNGU3NDc2ZmVjODU0MjBmOSIsImV4cCI6MTc2NjIzMzg4Mn0.RAerNGGvx3teDvC3sCVUGxx1_90rqZ_ah3dTIPqUzq4"; // Replace with your Pinata JWT
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${apiKey}`,
        },
      });
      const ipfsHash = response.data.IpfsHash;
      const url = `https://gateway.pinata.cloud/ipfs/${ipfsHash}`;
      setjobsideformpdf(url);
      setjobsideformpdfName(val.name);
      setloader(false);
    } catch (err) {
      console.log(err, "---");
    }

    // try {
    //   console.log("val===", val);
    //   const fileExtension = val.name.split(".").at(-1);
    //   const fileSize = val.size;
    //   const fileName = val.name;
    //   console.log("fileExtension===", fileExtension);
    //   console.log("fileSize===", fileSize);
    //   console.log("fileName===", fileName);
    //   if (
    //     fileExtension == "doc" ||
    //     fileExtension == "docx" ||
    //     fileExtension == "pdf"
    //   ) {
    //     setloader(true);

    //     const apiKey =
    //       "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDBGMTJDNzgxMzQxYjVEOTRBYWQ0YTljRTVmZjQ5ODMyYTMxMzI1OTYiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY5MzU3ODMxNjc2MCwibmFtZSI6Ik5GQyAifQ.u3gspIn2TJ9xjh4mfwnU3ysAUaPGGTsHPKgap9EsqRw"; // Replace with your NFT.Storage API key // Replace with your NFT.Storage API key
    //     const apiUrl = "https://api.nft.storage/upload";

    //     try {
    //       const response = await axios.post(apiUrl, val, {
    //         headers: {
    //           Authorization: `Bearer ${apiKey}`,
    //           "Content-Type": "application/json",
    //         },
    //       });
    //       console.log(response.data.value.cid);

    //       var pdf = `https://nftstorage.link/ipfs/${response.data.value.cid}`;
    //       setjobsideformpdf(pdf);
    //       setloader(false);
    //     } catch (err) {}
    //   } else {
    //     toast.error(
    //       "File does not support. You must use .doc or .docx  or .pdf"
    //     );
    //   }
    // } catch (error) {
    //   console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-");
    // }
  };

  const [sideformjobvalue, setsideformjobValue] = useState("");
  // const options = useMemo(() => countryList().getData(), []);
  const [jobsidevallidation, setjobsidevallidation] = useState();
  const changesideformjobHandler = (value) => {
    setsideformjobValue(value);
    console.log(value, "value");
    jobsideformInputvalues.jobsideformcountry = value.label;
  };

  const jobsideformValidation = async (validateName) => {
    try {
      const errors = {};
      const reg = /^([^0-9$%]*)$/;

      if (!validateName.jobsideformFirstName) {
        setjobsideformFirstNameErr(true);
        errors.jobsideformFirstName = "Must Enter Your First Name";
      } else if (reg.test(validateName.jobsideformFirstName)) {
        setjobsideformFirstNameErr(false);
      } else {
        setjobsideformFirstNameErr(true);
        errors.jobsideformFirstName = "Only should  alphabetic characters";
      }
      if (!validateName.jobsideformLastName) {
        setjobsideformLastNameErr(true);
        errors.jobsideformLastName = "Must Enter Your Last Name";
      } else if (reg.test(validateName.jobsideformLastName)) {
        setjobsideformLastNameErr(false);
      } else {
        setjobsideformLastNameErr(true);
        errors.jobsideformLastName = "Only should  alphabetic characters";
      }

      if (!validateName.jobsideformexperience) {
        setjobsideformexperienceErr(true);
        errors.jobsideformexperience = "Must Enter  Experience Details";
      } else {
        setjobsideformexperienceErr(false);
      }

      if (!validateName.jobsideformEmail) {
        setjobsideformEmailErr(true);
        errors.jobsideformEmail = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          validateName.jobsideformEmail
        )
      ) {
        setjobsideformEmailErr(true);
        errors.jobsideformEmail = "Invalid Email Address";
      } else {
        setjobsideformEmailErr(false);
      }

      if (!validateName.jobsideformcountry) {
        setjobsideformcountryErr(true);
        errors.jobsideformcountry = "Choose Your Country";
      } else {
        setjobsideformcountryErr(false);
      }

      if (!jobsideformmobileValue) {
        setjobsideformphoneNumberErr(true);
        errors.jobsideformPhoneNumber = " Enter Your Mobile Number";
      } else {
        setjobsideformphoneNumberErr(false);
      }
      if (!jobsideformpdf) {
        setjobsideformResumeErr(true);
        errors.jobsideresume = "Upload Your Resume";
      } else {
        setjobsideformResumeErr(false);
      }
      setjobsidevallidation(errors);
    } catch (error) {}
  };

  const jobsideFormSubmit = async () => {
    try {
      jobsideformValidation(jobsideformInputvalues);
      console.log(jobsideformInputvalues, "=-=-=-=-=-=-=-=-=");

      if (
        jobsideformFirstNameref.current == false &&
        jobsideformLastNameref.current == false &&
        jobsideformResumeref.current == false &&
        jobsideformEmailref.current == false &&
        jobsideformexperienceErrref.current == false &&
        jobsideformphoneNumberref.current == false &&
        jobsideformpdf != ""
      ) {
        var jobObj = {
          firstname: jobsideformInputvalues.jobsideformFirstName,
          lastName: jobsideformInputvalues.jobsideformLastName,
          Email: jobsideformInputvalues.jobsideformEmail,
          Experience: jobsideformInputvalues.jobsideformexperience,
          mobileNumber: jobsideformmobileValue,
          country: jobsideformInputvalues.jobsideformcountry,
          resume: jobsideformpdf,
          jobPosition: jobPositionValue,
          jobDepartment: jobDepartmentValue,
        };
        console.log(jobObj, "=-=-=-=-=-=-=-=-=");
        console.log(jobInputvalues, "=-=-=-=-=-=-=-=-=");

        var data = {
          apiUrl: httpService.jobuserFormSubmit,
          payload: jobObj,
        };
        var messageSent = await jobuserFormSubmit(data);
        if (messageSent.success == true) {
          toast.success(messageSent.message);
          window.location.href = "https://beleaftechnologies.com/sucesspage";
          jobInputvalues.jobFirstName = "";
          jobInputvalues.jobLastName = "";
          jobInputvalues.jobEmail = "";
          jobInputvalues.jobexperience = "";
          jobInputvalues.country = "";
          setjobDepartmentValue("");
          setjobPositionValue("");
        } else {
          toast.error(messageSent.message);
        }
      } else {
        // console.log("errororor-0-0-");
      }
    } catch (error) {
      // console.log(error, "errororor-0-0-");
    }
  };

  const upload_click = () => {
    uploadInput.current?.click();
  };
  return (
    <div className="career_details">
      {/* <Header /> */}
      <NewHead />

      <div className="paddin_immner">
        <main className=" carer_page">
          <div className="container">
            {pageloader == true ? (
              <>
                {/* <i className="ri-upload-2-line"></i> */}
                <img
                  width="100px "
                  src={loaderImage}
                  className=" d-block mx-auto imag_width_file_load"
                />
              </>
            ) : (
              <div className="row">
                <div className="col-lg-8">
                  {pageType == "intern" ? (
                    <div className="detals_career">
                      <div className="head">
                        {/* <h1>Head of Branding</h1> */}
                        <h1>{Details.internPosition}</h1>
                        {/* <p>
                    Lorem ipsum dolor sit amet consectetur pellentesque
                    pretium lorem risus auctor neque sit vitae integer arcu
                    consequat augue sed orci ultrice faucibus est sit at sed
                    interdum.
                  </p> */}
                        <p>{Details.internDescription}</p>
                        <div className="location">
                          {/* <span className="blod_clas">Madurai</span>{" "} */}
                          <span className="blod_clas">{Details.location}</span>{" "}
                          <div className="divide"></div>{" "}
                          <span>{Details.interntiming}</span>
                          {/* <div className="divide"></div> <span>Full time</span> */}
                        </div>
                      </div>
                      <hr />
                      <div className="body_text">
                        <p
                          dangerouslySetInnerHTML={{ __html: Details.content }}
                        ></p>

                        {/* <h2>Job description</h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipiscing elit
                    duis mauris fringilla et integer sed posuere nisl tortor
                    et sagittis molestie aenean cursus amet et amet tortor sem
                    vel diam est morbi tellus viverra urna pellentesque sit ac
                    amet vitae arcu mi eu mus at lectus lectus eu scelerisque
                    ut tincidunt nec tristique.
                  </p>
                  <h2>Job responsibilities</h2>
                  <p>
                    {" "}
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    quis ultricies sed non sodales morbi ornare non
                    ullamcorper nulla aliquet viverra bibendum nunc ac egestas
                    habitant.
                  </p>
                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      quis ultricies sed non sodales morbi ornare non{" "}
                    </li>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      quis ultricies sed non sodales morbi ornare non{" "}
                    </li>

                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      quis ultricies sed non sodales morbi ornare non{" "}
                    </li>

                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      quis ultricies sed non sodales morbi ornare non{" "}
                    </li>

                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      quis ultricies sed non sodales morbi ornare non{" "}
                    </li>
                  </ul>
                  <h3>Requirements</h3>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipiscing elit
                    orci fringilla massa tellus id nunc non facilisi velit
                    ultrices aliquam fusce mauris consequat ultricies sed ut
                    cras tortor amet risus viverra augue proin eget sem elit
                    pharetra blandit dolor senectus ante nulla convallis.
                  </p> */}
                        {detailsrref.current == "" ? (
                          ""
                        ) : (
                          <Button
                            data-toggle="modal"
                            data-target="#intern_apply"
                          >
                            Apply now <i className="ri-arrow-right-line"></i>
                          </Button>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="detals_career">
                      <div className="head">
                        {/* <h1>Head of Branding</h1> */}
                        <h1>{Details.jobPosition}</h1>
                        {/* <p>
                      Lorem ipsum dolor sit amet consectetur pellentesque
                      pretium lorem risus auctor neque sit vitae integer arcu
                      consequat augue sed orci ultrice faucibus est sit at sed
                      interdum.
                    </p> */}
                        <p>{Details.jobDescription}</p>
                        <div className="location">
                          {/* <span className="blod_clas">Madurai</span>{" "} */}
                          <span className="blod_clas">{Details.location}</span>{" "}
                          <div className="divide"></div>{" "}
                          <span>{Details.jobtiming}</span>
                          {/* <div className="divide"></div> <span>Full time</span> */}
                        </div>
                      </div>
                      <hr />
                      <div className="body_text">
                        <div
                          dangerouslySetInnerHTML={{ __html: Details.content }}
                        ></div>

                        {/* <h2>Job description</h2>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipiscing elit
                      duis mauris fringilla et integer sed posuere nisl tortor
                      et sagittis molestie aenean cursus amet et amet tortor sem
                      vel diam est morbi tellus viverra urna pellentesque sit ac
                      amet vitae arcu mi eu mus at lectus lectus eu scelerisque
                      ut tincidunt nec tristique.
                    </p>
                    <h2>Job responsibilities</h2>
                    <p>
                      {" "}
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      quis ultricies sed non sodales morbi ornare non
                      ullamcorper nulla aliquet viverra bibendum nunc ac egestas
                      habitant.
                    </p>
                    <ul>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                        quis ultricies sed non sodales morbi ornare non{" "}
                      </li>
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                        quis ultricies sed non sodales morbi ornare non{" "}
                      </li>

                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                        quis ultricies sed non sodales morbi ornare non{" "}
                      </li>

                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                        quis ultricies sed non sodales morbi ornare non{" "}
                      </li>

                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                        quis ultricies sed non sodales morbi ornare non{" "}
                      </li>
                    </ul>
                    <h3>Requirements</h3>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipiscing elit
                      orci fringilla massa tellus id nunc non facilisi velit
                      ultrices aliquam fusce mauris consequat ultricies sed ut
                      cras tortor amet risus viverra augue proin eget sem elit
                      pharetra blandit dolor senectus ante nulla convallis.
                    </p> */}
                        {detailsrref.current == "" ? (
                          ""
                        ) : (
                          <Button data-toggle="modal" data-target="#job_apply">
                            Apply now <i className="ri-arrow-right-line"></i>
                          </Button>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {pageType == "intern" ? (
                  <div className="col-lg-4">
                    <div className="career_form">
                      <h3 className="mb-3">Enter your details</h3>
                      {/* <p>{Details.internDescription}</p> */}
                      <form>
                        <div className="form-group">
                          <label htmlFor="email"> First Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="email"
                            placeholder="First Name"
                            name="internersideformFirstName"
                            value={internersideformFirstName}
                            minLength={3}
                            maxLength={25}
                            onChange={intern_sideformChangeData}
                          />
                          {internersideformFirstNameref.current &&
                          internersideformFirstNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {
                                internsideformvalidationErrors.internersideformFirstName
                              }{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Last Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            name="internersideformLastName"
                            value={internersideformLastName}
                            minLength={3}
                            maxLength={25}
                            onChange={intern_sideformChangeData}
                          />
                          {internersideformLastNameref.current &&
                          internersideformLastNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {
                                internsideformvalidationErrors.internersideformLastName
                              }{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Email address</label>
                          <input
                            type="email"
                            className="form-control fontcolor"
                            placeholder="Email Address"
                            name="internersideformEmail"
                            value={internersideformEmail}
                            onChange={intern_sideformChangeData}
                          />
                          {internersideformEmailref.current &&
                          internersideformEmailref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {
                                internsideformvalidationErrors.internersideformEmail
                              }{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Phone Number</label>

                          <PhoneInput
                            country={"in"}
                            value={internersideformmobileValue}
                            onChange={setInternersideformMobileValue}
                          />
                          {internersideformphoneNumberref.current &&
                          internersideformphoneNumberref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {
                                internsideformvalidationErrors.internersideformphoneNumber
                              }{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Education Details</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Education Details"
                            name="internersideformEducationDetails"
                            value={internersideformEducationDetails}
                            minLength={3}
                            maxLength={50}
                            onChange={intern_sideformChangeData}
                          />
                          {internersideformEducationDetailsref.current &&
                          internersideformEducationDetailsref.current ===
                            true ? (
                            <span className="text-danger">
                              {" "}
                              {
                                internsideformvalidationErrors.internersideformEducationDetails
                              }{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group mt-4">
                          <div className="filebupload" onClick={upload_click}>
                            <span>
                              <div className=" w-100">
                                {loader == false ? (
                                  <i className="ri-upload-2-line mr-2"></i>
                                ) : (
                                  <img
                                    src={loaderImage}
                                    className="imag_width_file"
                                  />
                                )}
                                {jobsideformpdf
                                  ? jobsideformpdfName
                                  : "Upload resume"}
                              </div>
                            </span>
                            <input
                              type="file"
                              accept="application/pdf,application/pdf,application/doc,application/docx"
                              className="form-control"
                              onChange={(e) =>
                                internersideformfileUpload(e.target.files[0])
                              }
                              ref={uploadInput}
                            />
                          </div>
                          {internsideformpdfErrref.current &&
                          internsideformpdfErrref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {
                                internsideformvalidationErrors.internsideformpdf
                              }{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <Button onClick={internsideFormSubmit}>Submit</Button>
                      </form>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-4">
                    <div className="career_form">
                      <h3 className="mb-3">Enter your details</h3>
                      {/* <p>{Details.jobDescription}</p> */}
                      <form>
                        <div className="form-group">
                          <label htmlFor="email"> First Name</label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="First Name"
                            name="jobsideformFirstName"
                            value={jobsideformFirstName}
                            minLength={3}
                            maxLength={25}
                            onChange={jobsideformChangeData}
                          />
                          {jobsideformFirstNameref.current &&
                          jobsideformFirstNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {jobsidevallidation.jobsideformFirstName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email"> Last Name</label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="last Name"
                            name="jobsideformLastName"
                            value={jobsideformLastName}
                            minLength={3}
                            maxLength={25}
                            onChange={jobsideformChangeData}
                          />
                          {jobsideformLastNameref.current &&
                          jobsideformLastNameref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {jobsidevallidation.jobsideformLastName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Email address</label>
                          <input
                            type="email"
                            className="form-control "
                            id="email"
                            placeholder="Email Address"
                            name="jobsideformEmail"
                            value={jobsideformEmail}
                            onChange={jobsideformChangeData}
                          />
                          {jobsideformEmailref.current &&
                          jobsideformEmailref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {jobsidevallidation.jobsideformEmail}{" "}
                            </span>
                          ) : (
                            ""
                          )}{" "}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Phone Number</label>
                          <PhoneInput
                            country={"in"}
                            value={jobsideformmobileValue}
                            onChange={setjobsideformMobileValue}
                          />
                          {jobsideformphoneNumberref.current &&
                          jobsideformphoneNumberref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {jobsidevallidation.jobsideformPhoneNumber}{" "}
                            </span>
                          ) : (
                            ""
                          )}{" "}
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Years of Experience</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Years of Experience"
                            name="jobsideformexperience"
                            value={jobsideformexperience}
                            onChange={jobsideformChangeData}
                          />
                          {jobsideformexperienceErrref.current &&
                          jobsideformexperienceErrref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {jobsidevallidation.jobsideformexperience}{" "}
                            </span>
                          ) : (
                            ""
                          )}{" "}
                        </div>
                        {/* <div className="form-group mt-4">
                        <label htmlFor="email">Country</label>

                        <Select
                          options={options}
                          value={sideformjobvalue}
                          onChange={changesideformjobHandler}
                        />
                        {jobsideformcountryref.current &&
                        jobsideformcountryref.current === true ? (
                          <span className="text-danger">
                            {" "}
                            {jobsidevallidation.jobsideformcountry}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div> */}
                        <div className="form-group mt-4">
                          <div className="filebupload" onClick={upload_click}>
                            <span className="d-flex  gap-3">
                              <div className="">
                                {/* <i className="ri-upload-2-line"></i>  */}
                                {loader == false ? (
                                  <i className="ri-upload-2-line"></i>
                                ) : (
                                  <img
                                    src={loaderImage}
                                    className="w-100 imag_width_file"
                                  />
                                )}
                              </div>
                              {internsideformpdf
                                ? sideforminternpdfName
                                : "Upload resume"}
                            </span>
                            <input
                              type="file"
                              accept="application/pdf,application/pdf,application/doc,application/docx"
                              className="form-control"
                              onChange={(e) =>
                                jobsideformfileUpload(e.target.files[0])
                              }
                              ref={uploadInput}
                            />
                          </div>
                          {jobsideformResumeref.current &&
                          jobsideformResumeref.current === true ? (
                            <span className="text-danger">
                              {" "}
                              {jobsidevallidation.jobsideresume}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <Button onClick={jobsideFormSubmit}>Submit</Button>
                      </form>
                    </div>
                  </div>
                )}

                <div
                  id="intern_apply"
                  className=" Applay_model modal fade"
                  role="dialog"
                >
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content ">
                      <div className="modal-body">
                        <button
                          type="button"
                          className="close posiiton"
                          data-dismiss="modal"
                        >
                          <i className="ri-close-line"></i>
                        </button>
                        <h3>Apply Now for Intern</h3>
                        <form>
                          <div className="form-group row">
                            <div className="col-sm-6 pt-3 ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="First Name"
                                name="internerFirstName"
                                value={internerFirstName}
                                minLength={3}
                                maxLength={25}
                                onChange={internChangeData}
                              />
                              {internerFirstNameref.current &&
                              internerFirstNameref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.internerFirstName}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-6 pt-3 ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Last Name"
                                name="internerLastName"
                                value={internerLastName}
                                minLength={3}
                                maxLength={25}
                                onChange={internChangeData}
                              />
                              {internerLastNameref.current &&
                              internerFirstNameref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.internerLastName}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-6 pt-3 ">
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Email Address"
                                name="internerEmail"
                                value={internerEmail}
                                onChange={internChangeData}
                              />
                              {internerEmailref.current &&
                              internerEmailref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.internerEmail}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-6 pt-3 ">
                              <PhoneInput
                                className="react-tel-input-sideform"
                                country={"in"}
                                value={internermobileValue}
                                onChange={setInternerMobileValue}
                              />
                              {internerphoneNumberref.current &&
                              internerphoneNumberref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.internerphoneNumber}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-12 pt-3 ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Education Details"
                                name="internerEducationDetails"
                                value={internerEducationDetails}
                                minLength={3}
                                maxLength={50}
                                onChange={internChangeData}
                              />
                              {internerEducationDetailsref.current &&
                              internerEducationDetailsref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {
                                    validationErrors.internerEducationDetails
                                  }{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-12 pt-3 ">
                              <div className="uploadfile">
                                <input
                                  type="file"
                                  accept="application/pdf,application/pdf,application/doc,application/docx"
                                  className="form-control"
                                  onChange={(e) =>
                                    internerfileUpload(e.target.files[0])
                                  }
                                />
                                <div className="flex_upload">
                                  {internpdf ? (
                                    <img
                                      src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1734704278/download_1_brdsui.jpg"
                                      className="w-100"
                                    />
                                  ) : loader == false ? (
                                    <i className="fas fa-file-upload"></i>
                                  ) : (
                                    <img src={loaderImage} className="w-100" />
                                  )}
                                  {/*                                  
                                  {loader == false ? (
                                    <i className="fas fa-file-upload"></i>
                                  ) : (
                                    <img src={loaderImage} className="w-100" />
                                  )} */}
                                  {internpdf ? (
                                    <p>{internpdfName}</p>
                                  ) : (
                                    <p>Upload File</p>
                                  )}

                                  {/* <p>Upload File</p> */}
                                </div>
                              </div>
                              {internpdfErrref.current &&
                              internpdfErrref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.internpdf}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            {/* <Image cloudName="blf" publicId="669799745475175.pdf" /> */}

                            <div className="col-lg-12">
                              <div className="banner_text_section p-0 pb-0 d-flex justify-content-center">
                                <Button
                                  className="m-0 ml-auto mr-auto mt-3"
                                  onClick={internFormSubmit}
                                >
                                  Submit
                                </Button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="job_apply"
                  className="Applay_model modal fade"
                  role="dialog"
                >
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-body">
                        <button
                          type="button"
                          className="close posiiton"
                          data-dismiss="modal"
                        >
                          <i className="ri-close-line"></i>
                        </button>
                        <h3>Apply Now Job</h3>
                        <form>
                          <div className="form-group row">
                            <div className="col-sm-6 pt-3 ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="First "
                                value={jobFirstName}
                                pattern="^[a-zA-Z\s]*$"
                                name="jobFirstName"
                                minLength={3}
                                maxLength={25}
                                onChange={jobChangeData}
                              />
                              {jobFirstNameref.current &&
                              jobFirstNameref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.jobFirstName}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-6 pt-3 ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Last Name"
                                value={jobLastName}
                                name="jobLastName"
                                minLength={3}
                                maxLength={25}
                                onChange={jobChangeData}
                              />
                              {jobLastNameref.current &&
                              jobLastNameref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.jobLastName}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-6 pt-3 ">
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Email Address"
                                value={jobEmail}
                                name="jobEmail"
                                onChange={jobChangeData}
                              />
                              {jobEmailref.current &&
                              jobEmailref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.jobEmail}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-6 pt-3 ">
                              <PhoneInput
                                country={"in"}
                                className="react-tel-input-sideform"
                                value={jobmobileValue}
                                onChange={setjobMobileValue}
                              />
                              {jobphoneNumberref.current &&
                              jobphoneNumberref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.jobPhoneNumber}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>

                            {/* <div className="col-sm-12 pt-3 ">
                            <Select
                              options={options}
                              value={value}
                              onChange={changeHandler}
                            />
                            {jobcountryref.current &&
                            jobcountryref.current === true ? (
                              <span className="text-danger">
                                {" "}
                                {validationErrors.jobcountry}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div> */}
                            <div className="col-sm-12 pt-3 ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Experience "
                                value={jobexperience}
                                name="jobexperience"
                                minLength={3}
                                maxLength={25}
                                onChange={jobChangeData}
                              />
                              {jobexperienceErrref.current &&
                              jobexperienceErrref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.jobexperience}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-sm-12 pt-3 ">
                              <div className="uploadfile">
                                <input
                                  type="file"
                                  accept="application/pdf,application/pdf,application/doc,application/docx"
                                  className="form-control"
                                  onChange={(e) =>
                                    jobfileUpload(e.target.files[0])
                                  }
                                />
                                <div className="flex_upload">
                                  {jobpdf ? (
                                    <img
                                      src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1734704278/download_1_brdsui.jpg"
                                      className="w-100"
                                    />
                                  ) : loader == false ? (
                                    <i className="fas fa-file-upload"></i>
                                  ) : (
                                    <img src={loaderImage} className="w-100" />
                                  )}
                                  {jobpdf ? (
                                    <p>{jobpdfName}</p>
                                  ) : (
                                    <p>Upload File</p>
                                  )}
                                </div>
                              </div>
                              {jobResumeref.current &&
                              jobResumeref.current === true ? (
                                <span className="text-danger">
                                  {" "}
                                  {validationErrors.resume}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-lg-12">
                              <div className="banner_text_section p-0 pb-0 d-flex justify-content-center mt-4">
                                <Button onClick={jobFormSubmit} className="m-0">
                                  Submit
                                </Button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default Home;
